import { TourModel } from 'api-hooks/tour/tour-list/tour-detail';
import { AuthorizationRules } from 'common/constants';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer, { DrawerProvider } from 'hooks/use-drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ListSalesPanel from '../panel/sales-list-panel';

export default function useTourSaleListAction(tour: TourModel) {
  const { t } = useTranslation();
  const { can } = useAuthorization();
  const drawer = useDrawer();
  const id = tour.id;

  const tourSaleListPermission = can(AuthorizationRules.ToursGetSale);
  const onGetTourSaleList = React.useCallback(() => {
    drawer.showCustom({
      render: (onClose) => (
        <DrawerProvider>
          <ListSalesPanel id={id} onClose={onClose} />
        </DrawerProvider>
      ),
    });
  }, [drawer, id]);

  const tourSaleListAction: PopoverMenuType = {
    key: `tour-sale-list-${id}`,
    label: t('common:sales_list'),
    onClick: onGetTourSaleList,
    isAllowed: tourSaleListPermission,
  };

  return {
    tourSaleListPermission,
    onGetTourSaleList,
    tourSaleListAction,
  };
}
